import { SelectProps } from "@components/Select/Select";
import { ID } from "@datassential/platform-ui-lib";
import { Select } from "@components/Select/index";
import { useCallback, useMemo } from "react";

type Props<I extends ID, T = string> = Omit<SelectProps<I, T>, 'value' | 'setValue'> & {
    value: I;
    setValue: (value: I) => void;
    onChange?: () => void;
}

const SelectSingle = <I extends ID, T = string>({
    value: rawValue,
    setValue: rawSetValue,
    onChange,
    ...props
}: Props<I, T>) => {
    const value = useMemo(
        (): I[] => [rawValue ?? null] as I[],
        [rawValue]
    );

    const setValue = useCallback(
        (newValue: I[]) => {
            rawSetValue(newValue.length > 0 ? newValue[0] : null as I);
            onChange?.();
        },
        [rawSetValue, onChange]
    );

    return (
        <Select
            value={value}
            setValue={setValue}
            {...props}
        />
    );
};

export default SelectSingle;